import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckCircleWidgetComponent } from '@library-shared/widget/check-circle-widget/check-circle-widget.component';
import { DxCheckBoxModule } from 'devextreme-angular';

@Component({
    selector: 'tti-check-box',
    templateUrl: './tti-check-box.component.html',
    styleUrls: ['./tti-check-box.component.scss'],
    imports: [CheckCircleWidgetComponent, DxCheckBoxModule]
})
export class TtiCheckBoxComponent implements OnInit {
    _value = false;
    @Output() valueChange = new EventEmitter<boolean>();
    @Input()
    get value(): boolean {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.valueChange.emit(this._value);
    }

    @Input() editWidth = null;

    @Input() editMode = false;

    @Input() validationGroup = null;

    @Input() required = false;

    @Output() onValueChanged = new EventEmitter<any>();

    constructor() {}

    ngOnInit() {}

    valueChanged(e: any) {
        this.onValueChanged.emit(e);
    }
}
